export const TIMELINE_WEB_TRACKING_EVENT_TYPE = {
  button_click: 'button_click',
  page_opened: 'page_opened',
  url_click: 'url_click'
}
